import { Injectable } from '@angular/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { err, ok, Result } from 'neverthrow';
import { FileType } from 'src/app/models/fileType';



@Injectable({
  providedIn: 'root'
})
export class FilePickerWebService {

  constructor() { }

  getFileFromDevice(types: typeof FileType[]): Promise<Result<File, any>> {
    let input = document.createElement('input');
    input.type = 'file';
    input.accept = types.join(', ')

    input.click();

    return new Promise((resolve, reject)=>{
      input.onchange = async () => {
        const file = Array.from(input.files)
        resolve(ok(file[0] as File));
      };
    })
  }


  getAnyFileFromDevice(): Promise<Result<File, any>> {
    let input = document.createElement('input');
    input.type = 'file';

    input.click();

    return new Promise((resolve, reject)=>{
      input.onchange = async () => {
        const file = Array.from(input.files)
        resolve(ok(file[0] as File));
      };
    })
  }

}
